import { AlertBanner } from '@latitude/alert-banner';

import { useSchemaMismatch } from './useSchemaMismatch';

export const SchemaMismatchBanner: React.FC = () => {
  const isStale = useSchemaMismatch();

  if (!isStale) {
    return null;
  }

  return (
    <AlertBanner
      variant="info"
      title="A new version of this page may be available"
      description="This tab is running an older version. Refresh to check for updates — unsaved changes on this page may be lost."
      buttonLabel="Refresh now"
      onActionClick={() => window.location.reload()}
      rawProps={{ role: 'status', 'aria-live': 'polite' }}
      data-testid="schema-mismatch-banner"
      className="sticky top-0 z-50 mb-6 bg-color-ref-ui-background-container"
    />
  );
};
